import React from 'react'
import styled from 'styled-components'
import Select from 'react-select'
import Recaptcha from 'react-recaptcha'
import Error from './Utils/Error'
import Cookies from 'universal-cookie'
import Spinner from './Utils/Spinner'
import { withAuth } from './AuthContext'
import { Link, withRouter } from 'react-router-dom'
import { isValidEmail } from '../utils/utils'
import {
  Container,
  ContainerFlexColumn,
  Input,
  Title,
  CustomSubtitle,
  ActionButtons,
  BackOutline,
  CustomSelect,
} from './Utils/CustomClasses'
import { shouldTranslateTo } from '../utils/utils'
import { gaEvents } from '../analytics/events'

const cookies = new Cookies()

const CustomContainer = styled(Container)`
  padding: 30px;

  @media screen and (max-width: 768px) {
    padding: 30px 10px;
  }
`

const SelectStyled = styled(Select)`
  width: 40vw;

  & > div:first-of-type {
    height: 55px;
  }

  @media screen and (max-width: 768px) {
    width: 90vw;
  }

  /* @media screen and (max-width: 600px) {
        height: 55px;
    } */
`

const Box = styled.div`
  background-color: #fff;
  padding: 40px;

  @media screen and (max-width: 768px) {
    padding: 20px;
  }
`

const Form = styled.form`
  text-align: left;
  width: 40vw;
  min-width: 400px;

  @media screen and (max-width: 768px) {
    width: -webkit-fill-available !important;
    min-width: unset !important;
  }
`

const SubmitButton = styled(ActionButtons)`
  margin-top: 30px;
  width: -webkit-fill-available;
  justify-content: center;
`

const LineBreak = styled.hr`
  width: 40vw;
  min-width: 400px;
  border-top: 1px solid rgba(0, 0, 0, 0.24);
  margin: 45px 0;

  @media screen and (max-width: 768px) {
    width: -webkit-fill-available !important;
    min-width: unset !important;
    margin: 30px 0;
  }
`

const GiftYourCustodianForm = (props) => {
  const [title, setTitle] = React.useState('')
  const [firstName, setFirstName] = React.useState('')
  const [lastName, setLastName] = React.useState('')
  const [relationship, setRelationship] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [passwordConfirmation, setPasswordConfirmation] = React.useState('')
  const [titleError, setTitleError] = React.useState(false)
  const [firstNameError, setFirstNameError] = React.useState(false)
  const [lastNameError, setLastNameError] = React.useState(false)
  const [relationshipError, setRelationshipError] = React.useState(false)
  const [emailError, setEmailError] = React.useState(false)
  const [passwordError, setPasswordError] = React.useState(false)
  const [error, setError] = React.useState({})
  const [captchaVerified, setCaptchaVerified] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [pageText, setPageText] = React.useState([])

  React.useEffect(() => {
    const savedCustodian = JSON.parse(localStorage.getItem('custodian'))
    if (savedCustodian) {
      setTitle(savedCustodian.title)
      setFirstName(savedCustodian.firstName)
      setLastName(savedCustodian.secondName)
      setRelationship(savedCustodian.customer_relationship)
      setEmail(savedCustodian.email)
      setPassword(savedCustodian.password)
      setPasswordConfirmation(savedCustodian.password_confirmation)
    }

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('GYGU-custodian-form', language, setPageText)
  }, [])

  const { history } = props

  const updateTitle = (e) => {
    setTitleError(false)
    setError(null)
    setTitle(e['value'])
  }

  const updateFirstName = (e) => {
    setFirstNameError(false)
    setError(null)
    setFirstName(e)
  }

  const updateLastName = (e) => {
    setLastNameError(false)
    setError(null)
    setLastName(e)
  }

  const updateRelationship = (e) => {
    setRelationshipError(false)
    setError(null)
    setRelationship(e)
  }

  const updateEmail = (e) => {
    setEmailError(false)
    setError(null)
    setEmail(e)
  }

  const updatePassword = (e) => {
    setPasswordError(false)
    setError(null)
    setPassword(e)
  }

  const updatePasswordConfirmation = (e) => {
    setPasswordError(false)
    setError(null)
    setPasswordConfirmation(e)
  }

  const HandleGift = (e) => {
    console.log(e.target.value)
  }

  var callback = function () {
    console.log('--')
  }

  var verifyCallback = function (response) {
    setError(null)
    if (response) {
      setCaptchaVerified(true)
    }
  }

  const SubmitForm = (e) => {
    e.preventDefault()

    // Validate title
    if (!title) {
      setTitleError(true)
      setError('Please add your title')
      return
    }

    // Validate first name
    if (!firstName) {
      setFirstNameError(true)
      setError('Please enter your first name')
      return
    }

    // Validate last name
    if (!lastName) {
      setLastNameError(true)
      setError('Please enter your last name')
      return
    }

    // Validate relationship
    if (!relationship) {
      setRelationshipError(true)
      setError('Please tell us your relationship with the gift recipient')
      return
    }

    // Validate email
    if (!isValidEmail(email)) {
      setEmailError(true)
      setError('Please enter a valid email address')
      return
    }

    // Validate password
    if (password && passwordConfirmation) {
      if (password !== passwordConfirmation) {
        setPasswordError(true)
        setError('Passwords do not match')
        return
      }
    } else {
      setPasswordError(true)
      if (password) {
        setError('Please confirm password')
      } else {
        setError('Please enter a password')
      }
      return
    }

    if (!captchaVerified) {
      setError('Please complete Recaptcha')
      return
    }

    setLoading(true)

    var custodian = {
      user_type: 'custodian',
      title: title,
      firstName: firstName,
      secondName: lastName,
      customer_relationship: relationship,
      dob: '1968-01-01',
      email: email,
      password: password,
      password_confirmation: passwordConfirmation,
      overfifty: 'Yes',
      address_line: '',
      second_address_line: '',
      country: '',
      city: '',
      country_region: '',
      is_new_city: false,
      locationId: null,
      isVerified: false,
      languages: [],

      discount_code:
        cookies.get('dC') != '' && cookies.get('dC') != null
          ? cookies.get('dC')
          : null,
      landing_page_code:
        cookies.get('tT') != '' && cookies.get('tT') != null
          ? cookies.get('tT')
          : null,
      source_code:
        cookies.get('sC') != '' && cookies.get('sC') != null
          ? cookies.get('sC')
          : null,
      price_code:
        cookies.get('pC') != '' && cookies.get('pC') != null
          ? cookies.get('pC')
          : null,
      currency_value:
        cookies.get('cV') != '' && cookies.get('cV') != null
          ? cookies.get('cV')
          : null,
      language_code:
        cookies.get('lC') != '' && cookies.get('lC') != null
          ? cookies.get('lC')
          : null,
      utm_source:
        cookies.get('utmS') != '' && cookies.get('utmS') != null
          ? cookies.get('utmS')
          : null,
      utm_medium:
        cookies.get('utmM') != '' && cookies.get('utmM') != null
          ? cookies.get('utmM')
          : null,
      utm_campaign:
        cookies.get('utmCa') != '' && cookies.get('utmCa') != null
          ? cookies.get('utmCa')
          : null,
      utm_content:
        cookies.get('utmCo') != '' && cookies.get('utmCo') != null
          ? cookies.get('utmCo')
          : null,
    }

    localStorage.setItem('custodian', JSON.stringify(custodian))

    axios
      .post('/api/register-gift/custodian/verify', custodian)
      .then((response) => {
        gaEvents.eventGeneric(
          'form_submit',
          'submitted',
          'GYGU custodian form B'
        )
        history.push('/gift-your-grown-up/step-2', {
          custodian: custodian,
        })
      })
      .catch((err) => {
        setError(err)
        setLoading(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <CustomContainer>
      {loading && <Spinner />}
      <Box>
        <BackOutline padding="4px 20px">
          <Link to="/gift-your-grown-up-b">{pageText[0]}</Link>
        </BackOutline>
        <ContainerFlexColumn center padding="80px 0" paddingSm="30px 0">
          <CustomSubtitle
            size="22px"
            sizemd="22px"
            sizesm="17px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[1]}`,
            }}
          />
          <LineBreak />
          <Title
            center
            smCenter
            size="30px"
            sizemd="25px"
            sizesm="22px"
            margin="0 0 50px 0"
            dangerouslySetInnerHTML={{ __html: `${pageText[2]}` }}
          />
          <Form onSubmit={(e) => HandleGift(e)}>
            {/* Title */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[16]}`,
              }}
            />
            <CustomSelect
              placeholder={pageText[17]}
              defaultValue={{
                value: title ? title : '',
                label: title ? title : 'Select..',
              }}
              className={titleError && 'error-border'}
              isDisabled={false}
              isLoading={false}
              isClearable={true}
              isRtl={false}
              isSearchable={true}
              name="title"
              options={[
                {
                  value: pageText[18],
                  label: pageText[18],
                },
                {
                  value: pageText[19],
                  label: pageText[19],
                },
                {
                  value: pageText[20],
                  label: pageText[20],
                },
              ]}
              onChange={(e) => updateTitle(e)}
            />
            {/* Name */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[5]}`,
              }}
            />
            <Input
              id="custodian-firstName"
              type="text"
              name="firstName"
              className={firstNameError && 'error-border'}
              placeholder={pageText[6]}
              required
              value={firstName}
              onChange={(e) => updateFirstName(e.target.value)}
            />
            {/* Last Name */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[7]}`,
              }}
            />
            <Input
              id="custodian-secondName"
              type="text"
              name="secondName"
              className={lastNameError && 'error-border'}
              placeholder={pageText[8]}
              required
              value={lastName}
              onChange={(e) => updateLastName(e.target.value)}
            />
            {/* Relationship */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[10]}`,
              }}
            />
            <Input
              id="relationship"
              type="text"
              name="customer_relationship"
              className={relationshipError && 'error-border'}
              placeholder={pageText[11]}
              required
              value={relationship}
              onChange={(e) => updateRelationship(e.target.value)}
            />
            {/* Email */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[3]}`,
              }}
            />
            <Input
              id="custodian-email"
              type="email"
              name="email"
              className={emailError && 'error-border'}
              placeholder={pageText[4]}
              required
              value={email}
              onChange={(e) => updateEmail(e.target.value)}
            />
            {/* Password */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[12]}`,
              }}
            />
            <Input
              id="password"
              type="password"
              name="password"
              className={passwordError && 'error-border'}
              placeholder={pageText[13]}
              required
              value={password}
              onChange={(e) => updatePassword(e.target.value)}
            />
            {/* Confirm Password */}
            <CustomSubtitle
              bold
              size="18px"
              margin="0 0 11px 0px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[14]}`,
              }}
            />
            <Input
              id="password_confirmation"
              type="password"
              name="password_confirmation"
              className={passwordError && 'error-border'}
              placeholder={pageText[15]}
              required
              value={passwordConfirmation}
              onChange={(e) => updatePasswordConfirmation(e.target.value)}
            />
            <Recaptcha
              sitekey={recaptchaPublicKey}
              render="explicit"
              verifyCallback={verifyCallback}
              onloadCallback={callback}
            />

            {error && <Error error={error} />}

            <SubmitButton
              padding="12px 14px"
              type="submit"
              onClick={(e) => SubmitForm(e)}
            >
              {pageText[9]}
            </SubmitButton>
          </Form>
        </ContainerFlexColumn>
      </Box>
    </CustomContainer>
  )
}

export default withRouter(withAuth(GiftYourCustodianForm))
